// QR Code Style Presets
// Various artistic and branded QR code styles

export const qrStylePresets = [
  {
    id: 'classic-black',
    name: 'Classic Black',
    icon: '⬛',
    description: 'Traditional black & white',
    config: {
      fgColor: '#000000',
      bgColor: '#FFFFFF',
      pattern: 'squares',
      cornerStyle: 'square',
      frameStyle: 'none',
      frameColor: '#000000',
      frameText: 'SCAN ME'
    }
  },
  {
    id: 'modern-dots',
    name: 'Modern Dots',
    icon: '🔵',
    description: 'Rounded dots with blue',
    config: {
      fgColor: '#626ed4',
      bgColor: '#FFFFFF',
      pattern: 'dots',
      cornerStyle: 'rounded',
      frameStyle: 'rounded',
      frameColor: '#626ed4',
      frameText: 'SCAN ME'
    }
  },
  {
    id: 'elegant-teal',
    name: 'Elegant Teal',
    icon: '💎',
    description: 'Professional teal with circle frame',
    config: {
      fgColor: '#02a499',
      bgColor: '#FFFFFF',
      pattern: 'rounded',
      cornerStyle: 'rounded',
      frameStyle: 'circle',
      frameColor: '#02a499',
      frameText: 'SCAN ME'
    }
  },
  {
    id: 'vibrant-purple',
    name: 'Vibrant Purple',
    icon: '🟣',
    description: 'Eye-catching purple with banner',
    config: {
      fgColor: '#6f42c1',
      bgColor: '#FFFFFF',
      pattern: 'dots',
      cornerStyle: 'rounded',
      frameStyle: 'bottom',
      frameColor: '#6f42c1',
      frameText: 'SCAN ME'
    }
  },
  {
    id: 'sunset-orange',
    name: 'Sunset Orange',
    icon: '🟠',
    description: 'Warm orange with rounded frame',
    config: {
      fgColor: '#f1734f',
      bgColor: '#FFFFFF',
      pattern: 'rounded',
      cornerStyle: 'rounded',
      frameStyle: 'rounded',
      frameColor: '#f1734f',
      frameText: 'SCAN NOW'
    }
  },
  {
    id: 'premium-gold',
    name: 'Premium Gold',
    icon: '✨',
    description: 'Luxury gold accent',
    config: {
      fgColor: '#d4a574',
      bgColor: '#FFFFFF',
      pattern: 'rounded',
      cornerStyle: 'rounded',
      frameStyle: 'bottom',
      frameColor: '#d4a574',
      frameText: 'TAP TO SCAN'
    }
  },
  {
    id: 'tech-cyan',
    name: 'Tech Cyan',
    icon: '💠',
    description: 'Modern tech cyan',
    config: {
      fgColor: '#38a4f8',
      bgColor: '#FFFFFF',
      pattern: 'dots',
      cornerStyle: 'rounded',
      frameStyle: 'rounded',
      frameColor: '#38a4f8',
      frameText: 'SCAN ME'
    }
  },
  {
    id: 'nature-green',
    name: 'Nature Green',
    icon: '🌿',
    description: 'Fresh green eco-friendly',
    config: {
      fgColor: '#02a499',
      bgColor: '#FFFFFF',
      pattern: 'rounded',
      cornerStyle: 'rounded',
      frameStyle: 'bottom',
      frameColor: '#02a499',
      frameText: 'ECO FRIENDLY'
    }
  },
  {
    id: 'danger-red',
    name: 'Urgent Red',
    icon: '🔴',
    description: 'Attention-grabbing red',
    config: {
      fgColor: '#ec4561',
      bgColor: '#FFFFFF',
      pattern: 'squares',
      cornerStyle: 'square',
      frameStyle: 'bottom',
      frameColor: '#ec4561',
      frameText: 'URGENT'
    }
  },
  {
    id: 'social-pink',
    name: 'Social Pink',
    icon: '💗',
    description: 'Social media pink',
    config: {
      fgColor: '#e83e8c',
      bgColor: '#FFFFFF',
      pattern: 'dots',
      cornerStyle: 'rounded',
      frameStyle: 'circle',
      frameColor: '#e83e8c',
      frameText: 'FOLLOW US'
    }
  },
  {
    id: 'corporate-navy',
    name: 'Corporate Navy',
    icon: '🏢',
    description: 'Professional navy blue',
    config: {
      fgColor: '#2a3042',
      bgColor: '#FFFFFF',
      pattern: 'squares',
      cornerStyle: 'square',
      frameStyle: 'rounded',
      frameColor: '#2a3042',
      frameText: 'BUSINESS'
    }
  },
  {
    id: 'minimal-gray',
    name: 'Minimal Gray',
    icon: '⚫',
    description: 'Subtle grayscale',
    config: {
      fgColor: '#6c757d',
      bgColor: '#FFFFFF',
      pattern: 'rounded',
      cornerStyle: 'rounded',
      frameStyle: 'none',
      frameColor: '#6c757d',
      frameText: 'SCAN ME'
    }
  }
];

export const frameStyles = [
  { value: 'none', label: 'No Frame', preview: '▢' },
  { value: 'rounded', label: 'Rounded Border', preview: '◯' },
  { value: 'circle', label: 'Circular Frame', preview: '⭕' },
  { value: 'bottom', label: 'Bottom Text Banner', preview: '📊' },
  { value: 'top', label: 'Top Text Banner', preview: '📌' },
  { value: 'full', label: 'Full Border with Text', preview: '🖼️' }
];

export const patternStyles = [
  { value: 'squares', label: 'Classic Squares', preview: '⬛' },
  { value: 'dots', label: 'Modern Dots', preview: '⚫' },
  { value: 'rounded', label: 'Rounded Corners', preview: '🔘' }
];

export const cornerStyles = [
  { value: 'square', label: 'Square Corners', preview: '▪️' },
  { value: 'rounded', label: 'Rounded Corners', preview: '🔹' },
  { value: 'dot', label: 'Dot Corners', preview: '⚪' }
];
